
import * as Form from '@radix-ui/react-form';
import styled from 'styled-components';

export const InputMessage = styled(Form.Message)`
`;
